import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress, Grid, Typography, Paper, Box, useTheme, useMediaQuery } from '@material-ui/core'

import { MapaCorpo } from 'views/ExamesRealizados/components/MapaCorpo/MapaCorpo'
import { CustomTable } from 'components'
import { getLabelRegiaoAnatomica } from 'helpers/labels'
import { capitalizeFirstLetter } from 'utils/helpers'
import useStyles from './styles'
import { useFormTatuagensECicatrizes } from './useFormTatuagensECicatrizes'

export const FormTatuagensECicatrizes = (props) => {
  const { idExameRealizado, idCadaver, setCicatrizesForm, setSVGTatuagensForm, odonto } = props
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const {
    processandoCicatrizes,
    cicatrizes,
    setCicatrizes,
    setSVGElements,
  } = useFormTatuagensECicatrizes({
    idExameRealizado,
    idCadaver,
    setCicatrizesForm,
    setSVGTatuagensForm,
  })

  const columns = [
    {
      title: 'Identificador',
      render: (rowData) => (
        <Typography className={classes.linhaTabela}>
          Marca {rowData.tableData?.id != null ? rowData.tableData.id + 1 : cicatrizes.indexOf(rowData) + 1}
        </Typography>
      ),
    },
    {
      title: 'Tipo',
      render: (rowData) => (
        <Typography className={classes.linhaTabela}>
          {rowData.tipo === 'OUTRO' ? capitalizeFirstLetter(rowData.outroTipo) : capitalizeFirstLetter(rowData.tipo)}
        </Typography>
      ),
    },
    {
      title: 'Região',
      render: (rowData) => (
        <Typography className={classes.linhaTabela}>
          {capitalizeFirstLetter(getLabelRegiaoAnatomica(rowData.regioes?.[0]))}
        </Typography>
      ),
    },
    {
      title: 'Descrição',
      render: (rowData) => (
        <Typography className={classes.linhaTabela}>
          {rowData.descricao || ' - '}
        </Typography>
      ),
    },
  ]

  return (
    <div>
      {processandoCicatrizes ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <div>
          {!processandoCicatrizes && (
            <MapaCorpo
              lesoes={cicatrizes}
              setLesoes={setCicatrizes}
              odonto={odonto}
              paraCicatriz
              setSVGElements={setSVGElements}
            />
          )}
          
          <Grid className={classes.fieldGroup} alignItems="center" container justify="space-between">
            <Grid className={classes.dados} alignItems="center" container justify="space-between" spacing={1}>
              <Grid item md={12} sm={12} xs={12} className={classes.tableContainer}>
                {isMobile ? (
                  cicatrizes && cicatrizes.length > 0 ? (
                    <Grid container spacing={2}>
                      {cicatrizes.map((item, index) => (
                        <Grid item xs={12} key={item.id || index}>
                          <Paper className={classes.cicatrizCard}>
                            <Box mb={1.5}>
                              <Typography
                                variant="subtitle2"
                                color="primary"
                                style={{ fontWeight: 'bold', fontSize: '14px' }}
                              >
                                Marca {index + 1}
                              </Typography>
                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Typography variant="body2" style={{ fontSize: '12px' }}>
                                  <b>Tipo:</b> {item.tipo === 'OUTRO' ? capitalizeFirstLetter(item.outroTipo) : capitalizeFirstLetter(item.tipo)}
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body2" style={{ fontSize: '12px' }}>
                                  <b>Região:</b> {capitalizeFirstLetter(getLabelRegiaoAnatomica(item.regioes?.[0]))}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Box mt={0.5}>
                                  <Typography variant="body2" style={{ fontSize: '12px' }}>
                                    <b>Descrição:</b> {item.descricao || '-'}
                                  </Typography>
                                </Box>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <Typography
                      style={{
                        fontSize: '12px',
                        padding: '24px',
                        textAlign: 'center',
                        color: '#999',
                        fontStyle: 'italic',
                      }}
                    >
                      Nenhuma cicatriz ou tatuagem registrada
                    </Typography>
                  )
                ) : (
                  <CustomTable
                    title=""
                    columns={columns}
                    data={cicatrizes || []}
                    isLoading={processandoCicatrizes}
                    emptyDataSourceMessage="Nenhuma cicatriz ou tatuagem registrada"
                    options={{
                      search: false,
                      pageSize: 10,
                      paging: false,
                      headerStyle: {
                        backgroundColor: odonto ? '#e8eaf6' : '#f4f6f8',
                        color: odonto ? '#1a237e' : 'inherit',
                        fontWeight: odonto ? 'bold' : 'normal',
                        fontSize: '12px',
                      },
                      toolbar: false,
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  )
}

FormTatuagensECicatrizes.propTypes = {
  idExameRealizado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  idCadaver: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setCicatrizesForm: PropTypes.func.isRequired,
  setSVGTatuagensForm: PropTypes.func.isRequired,
  odonto: PropTypes.bool,
}
